<template>
  <div>
    <HomeHero />
    <!-- <LazyAnimationsTextCarousel :list="descriptoresDeBeneficios" /> -->
    <LazyHomeInsights :class="sectionClass" />
    <LazyHomeFeatures :class="sectionClass" />
    <LazyHomeAboutUs :class="sectionClass" />
    <!-- <LazyHomeMetrics class="" /> -->
    <LazyHomeBICard :class="sectionClass" class="my-12" />
    <LazyHomeFaqs :class="sectionClass" />
    <LazyHomeCTABanner :class="sectionClass" />
  </div>
</template>
<script setup>
// import { useDisplay } from 'vuetify'
import companyInfo from '~/data/companyInfo'
// import {
//   // descriptoresDeServicio,
//   descriptoresDeBeneficios,
// } from "~/data/adjetives";
// const { mdAndUp } = useDisplay()
const sectionClass = "py-8 py-md-16";
useSeoMeta({
  title: "Inicio",
  description: companyInfo?.description,
  ogDescription: companyInfo?.description,
});
</script>

<style lang="scss" scoped></style>
